export default "__VITE_ASSET__C6HqQ$$V__"